module.exports = __webpack_public_path__ + "static/hero8-3692467df7a45c65df22e274319323b9.png";